export const RELOAD = "reload";
export const SOUND = "sound";
export const SCROLL_PARAM = "scroll";
export const MODAL_SCROLL_PARAM = "modal_scroll";
export const VACANCY_INFO = "vacancy_info";
export const SELECTED_ROW_POSITION_AFTER_GO_BACK = "middle";

export const DOCUMENT_VIEW_IDENTIFIER_HR_ORDER = "hr_order";
export const DOCUMENT_VIEW_IDENTIFIER_TRANSFER_STAFF = "transfer_staff";
export const DOCUMENT_VIEW_IDENTIFIER_HIRE_STAFF = "hire_staff";
export const DOCUMENT_VIEW_IDENTIFIER_FIRE_STAFF = "fire_staff";
export const PREVIOUS_PATHS = "previous_paths";

// "База кадров" jadvalida tanlangan status filtri localStorage'da shu kalit ostida saqlanadi (logout'gacha)
export const HR_PERSONNEL_BASE_STATUS_STORAGE_KEY = "hrPersonnelBaseStatus";

export const MEDIA_QUERY_BELOW_MD = "(max-width: 767.98px)";

export const MEDIA_QUERY_BELOW_LG = "(max-width: 991.98px)";

export const MEDIA_QUERY_SHORT_VIEWPORT = "(max-height: 575.98px)";

export const NATIONAL_PASSPORT = "national_passport";
export const DRIVERS_LICENSE = "driver_license";
export const ID_CARD = "id_card";

export const FETCHING_DATA_BY_ID = "FETCHING_DATA_BY_ID";
export const SUBMITING_FORM_LOADING = "submiting-form-loading";
export const RELOAD_LIST_KEY_DRAFT_TABLE = "relaod-list-key-draft-table";
export const RELOAD_LIST_KEY_PROJECT_TABLE = "relaod-list-key-project-table";

export const PAGE_VIEW_MODE = "pageViewMode";
export const ACTIVE_TAB = "activeTab";
export const DOCUMENT_ID = "documentId";
export const TEXT_AREA_MODAL_IS_LOADING = "text-area-modal-is-loading";
export const TYPE = "type";
export const DOCUMENT_VIEW_IDENTIFIER = "documentViewIdentifier";
export const DOCUMENT_IS_FETCHING = "document-is-fetching";
export const MAKE_RELATION_MODAL_KEY_NAME = "makeRelationModal";
export const ACCESS_VIEW_RELATED_DOCUMENT = "access-view-related-document";
export const DELETE_RELATED_DOCUMENT = "delete-related-document";
export const FETCH_RELATED_DOCUMENTS = "fetch-related-documents";
export const APPLY_FILTER = "apply-filter";
export const RESET_FILTER = "reset-filter";
export const ADVANCED_RESET_FILTER = "advanced-reset-filter";
export const MINIMIZED_MODALS_STORE = "minimized-modals-store";
export const ERROR_STAFF_IN_BUSINESSTRIP = "error-staff-in-businesstrip";

export const COMMON_IDENTIFIERS = {
  application_submission_types: "application_submission_types",
  blank_types: "blank_types",
  case_number: "case_number",
  complaint: "complaint",
  countries: "countries",
  distinctive_marks: "distinctive_marks",
  districts_and_cities: "districts_and_cities",
  document_languages: "document_languages",
  document_subjects: "document_subjects",
  documentjournal: "documentjournal",
  documentview: "documentview",
  organization: "organization",
  regions: "regions",
  sending_and_receiving_methods: "sending_and_receiving_methods",
  tags: "tags",
  urgency_category: "urgency_category",
};

// Ierarxik lug'atlar: bola lug'at -> ota lug'at.
// Faqat shu yerdagi lug'atlarda element formasida «Ota element» maydoni ko'rinadi va
// tanlash oynalarida kaskad (ota tanlansa — bolalari) ishlaydi. Qolgan lug'atlar tekis.
// Backenddagi ro'yxat bilan mos bo'lishi shart:
// Germes.DictionaryService/DictionaryService.Infrastructure/Constants/DictionaryHierarchy.cs
export const DICTIONARY_PARENT_MAP: Record<string, string> = {
  [COMMON_IDENTIFIERS.districts_and_cities]: COMMON_IDENTIFIERS.regions,
  [COMMON_IDENTIFIERS.regions]: COMMON_IDENTIFIERS.countries,
};

/** Lug'at ierarxikmi — element uchun ota tanlash mumkinmi. */
export const getParentDictionaryIdentifier = (dictionaryIdentifier?: string): string | undefined =>
  dictionaryIdentifier ? DICTIONARY_PARENT_MAP[dictionaryIdentifier] : undefined;

// Maydon nomi ATAYIN ota lug'atga qarab tanlanadi: viloyat kartasida «Mamlakat»,
// tuman kartasida «Viloyat». Texnik atama («yuqori turuvchi element») foydalanuvchiga
// hech narsa aytmaydi, tabiiy so'z esa darrov tushunarli.
// Ro'yxatda mos kalit bo'lmasa — umumiy `parentElement` ga qaytadi.
export const getParentFieldLabelKey = (dictionaryIdentifier?: string): string => {
  const parent = getParentDictionaryIdentifier(dictionaryIdentifier);
  return parent ? `dictionaryParent.label.${parent}` : "parentElement";
};

export const getParentFieldPlaceholderKey = (dictionaryIdentifier?: string): string => {
  const parent = getParentDictionaryIdentifier(dictionaryIdentifier);
  return parent ? `dictionaryParent.placeholder.${parent}` : "selectParentElement";
};

// Kaskad so'rovlarida otasi ko'rsatilmagan elementlar ham qaytsin.
// Migratsiya davri uchun: mijoz qo'lda qo'shgan va hali biriktirilmagan elementlar
// ro'yxatdan yo'qolib qolmasligi kerak. Hammasi bog'langach `false` qilinadi.
export const DICTIONARY_INCLUDE_ORPHANS = true;

export const Space = "␣";

// Xodim/nomzod rasmi (avatar) uchun ruxsat etilgan formatlar - fayl dialogida ham, kodda ham bir joydan boshqariladi.
// HEIC/HEIF - Apple qurilmalarining standart rasm formati; uni faqat macOS/iOS brauzeri ocha oladi.
export const ACCEPTED_AVATAR_APPLE_EXTENSIONS = [".heic", ".heif"];
export const ACCEPTED_AVATAR_EXTENSIONS = [".jpg", ".jpeg", ".png", ...ACCEPTED_AVATAR_APPLE_EXTENSIONS];
export const ACCEPTED_AVATAR_MIME_TYPES = [
  "image/jpg",
  "image/jpeg",
  "image/pjpeg",
  "image/png",
  "image/heic",
  "image/heif",
  "image/heic-sequence",
  "image/heif-sequence",
];
// macOS fayl oynasi kengaytma emas, MIME tur bo'yicha filtrlaydi - shuning uchun ikkalasi ham yoziladi.
export const ACCEPTED_AVATAR_ACCEPT_ATTR = ".jpg,.jpeg,.png,.heic,.heif,image/jpeg,image/png,image/heic,image/heif";
